var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9655 10.9437L25.6824 4.65919C25.4734 4.45021 25.2254 4.28443 24.9523 4.17132C24.6793 4.05821 24.3867 4 24.0912 4C23.7957 4 23.503 4.05821 23.23 4.17132C22.957 4.28443 22.709 4.45021 22.5 4.65919L5.15954 22.0011C4.9497 22.2092 4.78333 22.4571 4.67011 22.7301C4.55689 23.0031 4.49907 23.296 4.50001 23.5915V29.8761C4.50001 30.4728 4.73706 31.0451 5.15902 31.4671C5.58098 31.889 6.15327 32.1261 6.75001 32.1261H13.0345C13.3301 32.127 13.6229 32.0692 13.896 31.956C14.169 31.8427 14.4168 31.6764 14.625 31.4665L31.9655 14.1261C32.1745 13.9171 32.3402 13.6691 32.4534 13.3961C32.5665 13.123 32.6247 12.8304 32.6247 12.5349C32.6247 12.2394 32.5665 11.9468 32.4534 11.6737C32.3402 11.4007 32.1745 11.1527 31.9655 10.9437ZM7.21548 23.1261L19.125 11.2165L21.472 13.5636L9.56251 25.4717L7.21548 23.1261ZM6.75001 25.8415L10.7845 29.8761H6.75001V25.8415ZM13.5 29.4106L11.153 27.0636L23.0625 15.154L25.4095 17.5011L13.5 29.4106ZM27 15.9106L20.7155 9.62607L24.0905 6.25107L30.375 12.5342L27 15.9106Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a7f59810d2d5a5871be545bea7ee99d7.svg";
export { ForwardRef as ReactComponent };